/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import ChildTraining from "./Training";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { showModal, hideModal } from "actions";
import { Trans } from "react-i18next";
import Helpers from "util/helpers";
import { SCORMURL, ENV_NAME } from "util/constant";
import toastr from "toastr";
import { api } from "api";
import ApproveModal from "./ApproveModal";

class Training extends Component {
  rowClassName = "";

  state = {
    showingChildren: false,
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (type, dateString) => {
    //1 = ELearning
    if (type !== 1)
      return (
        <>
          {this.renderDate(dateString)}
          <br />
          {this.renderTime(dateString)}
        </>
      );
    else return this.renderDate(dateString);
  };

  renderTrainingMethodIcon = (label, isParent) => {
    if (isParent) {
      let icon = "iconmford fo-icon-add";
      if (!this.state.showingChildren) icon = "iconmford fo-icon-remove";
      return (
        <td
          // onClick={() => this.toggleChildren()}
          className="showGrup openCloseBtn"
          style={{
            textAlign: "left",
            color: "rgb(45, 150, 205)",
            paddingLeft: "25px",
            fontSize: "20px",
          }}
        >
          <span className={icon}></span>
        </td>
      );
    } else {
      switch (label) {
        case "Virtual Classroom":
          return (
            <td className="showGrup">
              <span className="iconmford fo-icon-tv">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </span>
            </td>
          );
        default:
          return (
            <td>
              <span className="iconmford fo-icon-class"></span>
            </td>
          );
      }
    }
  };

  registerVideo = (training) => {
    const timePlanId = training.timeplans[0].timePlanId;

    if (
      this.props.t.employeeRegisteredId !==
      "00000000-0000-0000-0000-000000000000"
    ) {
      let langCode = Helpers.getLangCode(localStorage.getItem("i18nextLng"));
      window.open(
        `${SCORMURL}/index?employeeCode=${this.props.employeeCode}&registeredTrainingId=${this.props.t.employeeRegisteredId}&langCode=${langCode}&env=${ENV_NAME}`
      );
      return;
    }

    this.props.onProcessBegin();
    api
      .post("/api/training-catalog/registration", { timePlanId: timePlanId })
      .then((response) => {
        this.props.refresh();
        let langCode = Helpers.getLangCode(localStorage.getItem("i18nextLng"));
        window.open(
          `${SCORMURL}/index?employeeCode=${this.props.employeeCode}&registeredTrainingId=${response.data.data.id}&langCode=${langCode}&env=${ENV_NAME}`
        );
      })
      .catch((err) => {
        toastr.error(err.response.data.message);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  renderContinueAction = (training) => {
    if (training.timeplans === null && training.timeplans.length === 0)
      return null;
    return (
      <td>
        <a
          onClick={() => {
            if (this.props.billable) {
              this.props.showModal({
                modalType: "TrainingCatalog",
                modalTitle: (
                  <span>
                    <Trans>trainingcatalog_premiumtraining</Trans>
                  </span>
                ),
                modalContent: (
                  <ApproveModal
                    training={training}
                    onCancel={() => this.props.hideModal()}
                    onSuccess={() => this.props.refresh()}
                  />
                ),
                modalFooter: null,
                modalElementId: "trainingCatalogModal",
              });
            } else {
              this.registerVideo(training);
            }
          }}
        >
          <span className="icon-icon-play"></span>
        </a>
      </td>
    );
  };

  renderStatusChart = (status) => {
    if (status === 0) {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart orange">
            <path
              className="circle-bg"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    } else if (status < 100) {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart orange">
            <path
              className="circle-bg"
              d="M18 2.0845          a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${status}, 100`}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    } else {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart green">
            <path
              className="circle-bg"
              d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${status}, 100`}
              d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    }
  };

  renderChildren = (t) => {
    if (t.isParent && this.state.showingChildren === false) {
      let childTrainings = t.childTrainings.map((ct) => {
        return (
          <React.Fragment key={ct.training.id}>
            <DesktopBreakpoint>
              <ChildTraining
                key={ct.training.id}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </DesktopBreakpoint>
            <TabletBreakpoint>
              <ChildTraining
                key={ct.training.id}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </TabletBreakpoint>
          </React.Fragment>
        );
      });
      return (
        <>
          <DesktopBreakpoint>
            <tr>
              <td colSpan="10">
                <table width="100%">
                  <tbody>
                    <tr className="child">
                      <td className="child">
                        <table className="table">
                          <tbody>{childTrainings}</tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </DesktopBreakpoint>
          <TabletBreakpoint>
            <tr>
              <td colSpan="2" className="accordionArea">
                <div className="accordion" id="accordionDays">
                  {childTrainings}
                </div>
              </td>
            </tr>
          </TabletBreakpoint>
        </>
      );
    }
  };

  renderTabletModeDetail = (t) => {
    if (this.state.showingChildren) {
      return (
        <tr className="child">
          <td className="child" colSpan="2">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </td>
                  <td>{t.trainingLocation ?? ""}</td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Süre">10017</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? `${t.timeplans[0].duration}`
                      : null}
                    <sup>
                      <Trans desc="GÜN">10388</Trans>
                    </sup>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Durum">10018</Trans>
                    </div>
                  </td>
                  <td>
                    <div id="durumChart_1" data-percent="34">
                      <div>{this.renderStatusChart(t.score)}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].startDate
                      )
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].endDate
                      )
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle"></div>
                  </td>
                  {this.renderContinueAction(t)}
                </tr>
                {this.renderChildren(t)}
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else return null;
  };

  render() {
    const { t, isChild } = this.props;
    return (
      <>
        {this.props.spinner}
        <DesktopBreakpoint>
          <tr className="grupEgitim" key={t.id}>
            {this.renderTrainingMethodIcon(t.trainingMethod.label, t.isParent)}
            <td className="showGrup">{t.training.name}</td>
            <td className="showGrup">{t.trainingLocation ?? ""}</td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? `${t.timeplans[0].duration}`
                : null}
              <sup>
                <Trans desc="GÜN">10388</Trans>
              </sup>
            </td>
            <td className="showGrup">
              <div id="durumChart_1" data-percent="34">
                {this.renderStatusChart(t.score)}
              </div>
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].startDate
                )
                : null}
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].endDate
                )
                : null}
            </td>
            {this.renderContinueAction(t)}

            <td></td>
          </tr>
          {this.renderChildren(t)}
        </DesktopBreakpoint>
        <TabletBreakpoint>
          {isChild ? (
            <div
              key={t.training.id}
              className="card"
              style={{ marginBottom: "0" }}
            >
              <div className="card-header">
                <a className="btn btn-link" type="button">
                  <h2 className="mb-0">{t.training.name}</h2>
                </a>
              </div>
            </div>
          ) : (
            <tr
              key={t.training.id}
              className={this.rowClassName}
              onClick={() => this.toggleChildren()}
            >
              {this.renderTrainingMethodIcon(
                t.trainingMethod.label,
                t.isParent
              )}
              <td className="showGrup">{t.training.name}</td>
            </tr>
          )}
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, {
  showModal,
  hideModal,
})(containsLongRunningProcess(Training));
